module.exports = __webpack_public_path__ + "img/chat-icon.aa58c4a9.svg";